import hash from 'object-hash';

import { useAppSelector } from '@/features/hooks';
import { rootQueriesApi, rootSelectors } from '@/features/store';
import useAppFetch from '@/hooks/useAppFetch';

const useFiltersData = () => {
  const [fetchFilters] = rootQueriesApi.filters.useLazyGetFiltersQuery();
  const [fetchAggregateFilters, aggregateFiltersQueryResult] =
    rootQueriesApi.filters.useLazyGetAggregateFiltersQuery();

  const parameters = useAppSelector(rootSelectors.filters.parametersSelector);
  const aggregateParameters = useAppSelector(
    rootSelectors.filters.aggregateParametersSelector,
  );
  const filtersQueryResult = useAppSelector(rootSelectors.filters.dataSelector);
  const aggregateFiltersQueryResultFromStore = useAppSelector(
    rootSelectors.filters.aggregateDataSelector,
  );

  const ssrKey = hash(aggregateParameters);
  const isSkip = !filtersQueryResult.data;

  useAppFetch(
    async () => {
      await fetchFilters(parameters, true).unwrap();
    },
    [],
    { ssr: hash(parameters) },
  );

  useAppFetch(
    async () => {
      if (filtersQueryResult.data) {
        await fetchAggregateFilters(aggregateParameters, true).unwrap();
      }
    },
    [ssrKey, isSkip],
    { ssr: ssrKey, skip: isSkip },
  );

  return {
    ...aggregateFiltersQueryResult,
    currentData: aggregateFiltersQueryResult.currentData,
    data: aggregateFiltersQueryResult.data ?? aggregateFiltersQueryResultFromStore.data,
    isUninitialized: aggregateFiltersQueryResultFromStore.isUninitialized
      ? filtersQueryResult.isUninitialized
      : false,
    isLoading: filtersQueryResult.isLoading || aggregateFiltersQueryResult.isLoading,
    isFetching: aggregateFiltersQueryResult.isFetching,
    isSuccess: filtersQueryResult.isSuccess && aggregateFiltersQueryResult.isSuccess,
    error: filtersQueryResult.error || aggregateFiltersQueryResult.error,
    isError: filtersQueryResult.isError || aggregateFiltersQueryResult.isError,
    status: aggregateFiltersQueryResultFromStore.isUninitialized
      ? aggregateFiltersQueryResult.status
      : aggregateFiltersQueryResultFromStore.status,
  } as typeof aggregateFiltersQueryResult;
};

export default useFiltersData;
